<template>
    <svg :width="size" :height="size" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 16L24 7L40 16V32L24 41L8 32V16Z"
            :stroke="color"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M8 16L24 25L40 16" :stroke="color" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M24 25V41" :stroke="color" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M30 20L30 14" :stroke="color" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M27 17L30 14L33 17" :stroke="color" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M18 14L18 20" :stroke="color" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M15 17L18 20L21 17" :stroke="color" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>

<script>
export default {
    name: 'StockMovementIcon',
    props: {
        size: {
            type: [Number, String],
            default: 24,
        },
        color: {
            type: String,
            default: 'currentColor',
        },
    },
}
</script>
